import { Controller, useFormContext } from "react-hook-form";
import { View } from "react-native-ui-lib";
import { FlatActionList } from "@towersystems/roam-common-native";
import { useTranslation } from "react-i18next";
import { ApiVaultKeyFormValues } from "../types";
import { KeyTypesMap } from "../constants";

export interface SelectKeyTypeProps {
  onSelect?(): void;
}

export const SelectKeyType = (props: SelectKeyTypeProps) => {
  const { t } = useTranslation("api_key_vault");
  const { getValues, setValue } = useFormContext<ApiVaultKeyFormValues>();
  const watchedKeyType = getValues("apiKeyType");
  return (
    <View>
      <FlatActionList
        items={KeyTypesMap.map((keyType) => ({
          key: keyType.value,
          title: keyType.label,
          subTitle: keyType.description,
          selected: keyType.value === watchedKeyType,
          onPress: () => {
            setValue("apiKeyType", keyType.value);
            if (props.onSelect) {
              props.onSelect();
            }
          },
        }))}
      />
    </View>
  );
};
